import type { Meetup } from '../services/api';

type ReservationActionState = Pick<
  Meetup,
  | 'kind'
  | 'status'
  | 'direction'
  | 'proposed_at'
  | 'duration_minutes'
  | 'call_link_state'
  | 'pending_reschedule'
>;

export function reservationExecutionIsLocked(reservation: ReservationActionState): boolean {
  return reservation.kind === 'call'
    && ['in_progress', 'already_completed', 'expired']
      .includes(reservation.call_link_state ?? '');
}

export function reservationEndTime(reservation: ReservationActionState): number {
  return new Date(reservation.proposed_at).getTime()
    + Math.max(1, reservation.duration_minutes) * 60_000;
}

export function canProposeReservationReschedule(
  reservation: ReservationActionState,
  nowMs: number,
): boolean {
  return reservation.status === 'accepted'
    && !reservation.pending_reschedule
    && !reservationExecutionIsLocked(reservation)
    && reservationEndTime(reservation) > nowMs;
}

export function canAcceptReservationReschedule(
  reservation: ReservationActionState,
  nowMs: number,
): boolean {
  return reservation.status === 'accepted'
    && !reservationExecutionIsLocked(reservation)
    && reservationEndTime(reservation) > nowMs;
}

export function canCancelReservation(reservation: ReservationActionState): boolean {
  return (reservation.status === 'pending' && reservation.direction === 'sent')
    || (reservation.status === 'accepted' && !reservationExecutionIsLocked(reservation));
}
